import { WorkItem } from "../models/WorkItem";

export function getWorkItem(): WorkItem | undefined {
  const storedWorkItem = sessionStorage.getItem("workItem");
  let workItem;
  if (storedWorkItem) {
    workItem = JSON.parse(storedWorkItem) as WorkItem;
  }
  return workItem;
}

export function setWorkItem(item: WorkItem): void {
  sessionStorage.setItem("workItem", JSON.stringify(item));
}

export function unsetWorkItem(): void {
  sessionStorage.removeItem("workItem");
}

export const eventDispatchers: string[] = [
  "openWorkItems",
  "openMyWorkItems",
  "openWorkGroups",
  "openWorkBuilder",
];
